import React, {Suspense} from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// import reportWebVitals from './reportWebVitals';
import {ApiProvider} from "./util/Requests";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import UserManagementPage from "./pages/UserManagementPage";
import GlobalLoadingModal from "./util/GlobalLoadingModal";
import NavigationMenu from "./components/Navigation/NavigationMenu";

const roott = document.getElementById('reactive-root');

const params = (new URLSearchParams(window.location.search));

if (params.has("pat")) {
    let pat = params.get("pat");

    let links = document.querySelectorAll("#primary-menu-list a");

    [...links].filter(it => !it.href.includes("wp-login")).forEach(link => {
        let url = new URL(link.href);

        url.searchParams.set("pat", pat);

        link.href = url.toString();
    });
}

if (roott) {
    const root = ReactDOM.createRoot(roott);

    const LocationsPage = React.lazy(() => import('./pages/LocationsPage'));
    const QC_Page = React.lazy(() => import('./pages/QC_Page'));
    const ReportsPage = React.lazy(() => import('./pages/ReportsPage'));
    const ListWorkordersPage = React.lazy(() => import('./pages/ListWorkordersPage'));
    const ViewWorkorderPage = React.lazy(() => import('./pages/ViewWorkorderPage'));
    // const ViewWorkorderPageTesting = React.lazy(() => import('./pages/ViewWorkorderPageTesting'));
    const ListCrewsPage = React.lazy(() => import('./pages/ListCrewsPage'));
    const CalendarPage = React.lazy(() => import('./pages/calendars/CalendarPage'));
    const SchedulersCalendarPage = React.lazy(() => import('./pages/calendars/SchedulersCalendarPage'));
    const IVRPage = React.lazy(() => import('./pages/calendars/IVRPage'));
    const SubsPage = React.lazy(() => import('./pages/SubsPage'));
    const UserManagementPage = React.lazy(() => import('./pages/UserManagementPage'));
    const ReportsLandingPage = React.lazy(() => import('./pages/ReportsLandingPage'));
    const AdminHomepage = React.lazy(() => import('./pages/AdminHomepage'));
    const UploadTesting = React.lazy(() => import('./pages/UploadTesting'));
    const OperationsCalendar = React.lazy(() => import('./pages/calendars/OperationsCalendar'));
    const CompliancePage = React.lazy(() => import('./pages/calendars/CompliancePage'));

    root.render(
        // <React.StrictMode>
            <ApiProvider>
                <Suspense fallback={<GlobalLoadingModal show={true}/>}>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/wo-status/" element={<QC_Page/>}/>
                            <Route path="/neo-list-locations/" element={<LocationsPage/>}/>
                            <Route path="/neo-view-workorder/" element={<ViewWorkorderPage/>}/>
                            <Route path="/neo-list-workorders/" element={<ListWorkordersPage/>}/>
                            <Route path="/dashboard/" element={<AdminHomepage/>}/>
                            <Route path="/testpage/" element={<UploadTesting/>}/>
                            <Route path="/reports/" element={<ReportsLandingPage/>}/>
                            <Route path="/neo-calendar/" element={<CalendarPage/>}/>
                            <Route path="/schedulers-calendar/" element={<SchedulersCalendarPage />}/>
                            <Route path="/ivr-page/" element={<IVRPage />}/>
                            <Route path="/neo-list-crews/" element={<ListCrewsPage/>}/>
                            <Route path="/reports-testing/" element={<ReportsPage/>}/>
                            <Route path="/view-subs/" element={<SubsPage/>}/>
                            <Route path="/user-management/" element={<UserManagementPage/>}/>
                            <Route path="/operations-calendar/" element={<OperationsCalendar/>}/>
                            <Route path="/compliance-page/" element={<CompliancePage/>}/>
                        </Routes>
                    </BrowserRouter>
                </Suspense>
            </ApiProvider>
        // </React.StrictMode>
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    // reportWebVitals();
}
